import { render, staticRenderFns } from "./EducationalVideo.vue?vue&type=template&id=27130b70&scoped=true"
import script from "./EducationalVideo.vue?vue&type=script&lang=js"
export * from "./EducationalVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27130b70",
  null
  
)

export default component.exports